// extracted by mini-css-extract-plugin
export var date = "HeroColumns-module--date--9671a";
export var heroButton = "HeroColumns-module--heroButton--5ca22";
export var heroButtonsWrapper = "HeroColumns-module--heroButtonsWrapper--e8aac";
export var heroContent = "HeroColumns-module--heroContent--163d1";
export var heroSubTitle = "HeroColumns-module--heroSubTitle--aaa68";
export var heroTitle = "HeroColumns-module--heroTitle--2540d";
export var heroWeb = "HeroColumns-module--heroWeb--aaee8";